import StringMask from 'string-mask';

export const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
    * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d.toFixed(1);
};

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export const isMobile = () => {
  if (window.innerWidth > 768) {
    return false;
  }
  return true;
};

export const maskPhone = (phone) => {
  if (phone !== null && phone.trim().length > 10) {
    const phoneMask = new StringMask('(00) 00000-0000');
    const maskedPhone = phoneMask.apply(phone);
    return maskedPhone;
  }
  const phoneMask = new StringMask('(00) 0000-0000');
  const maskedPhone = phoneMask.apply(phone);
  return maskedPhone;
};
export const maskCep = (cep) => {
  if (cep !== null) {
    const cepMask = new StringMask('00000-000');
    const maskedCep = cepMask.apply(cep);
    return maskedCep;
  }
};

export const isEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) { return false; }
  }
  return true;
};
